export function version(animation) {
  return animation && (
    animation.final ? '最終稿' : animation.title
  );
}
